// src/services/api.js
/**
 * API service for communicating with the backend
 */

// Base API URL - Change this based on environment

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://api.agentsamur.ai" // Production API URL
    : "http://localhost:5000"); // Development API URL

console.log("API URL being used:", API_BASE_URL); // Add this temporarily for debugging

/**
 * Send a chat message to the AI assistant
 *
 * @param {string} message - The user's message
 * @returns {Promise} - Response from the API
 */
export const sendChatMessage = async (message) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending chat message:", error);
    throw error;
  }
};

/**
 * Check API health/status
 *
 * @returns {Promise} - Health status of the API
 */
export const checkApiHealth = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/health`);
    return await response.json();
  } catch (error) {
    console.error("API health check failed:", error);
    return { status: "error", message: "Could not connect to API" };
  }
};
